export const logoInputs = [
  {
    name: "link",
    type: "url",
    required: true,
    defaultValue: "/",
  },
  {
    name: "srcDark",
    type: "file",
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F9d1d2ffe26704533a8ad5fbf1abac751",
  },
  {
    name: "srcLight",
    type: "file",
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F1ee41566ad9d4c978d68fd13d262bcec",
  },
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "",
  },
  {
    name: "alt",
    type: "string",
    required: true,
    defaultValue: "Logo",
  },
  {
    name: "width",
    type: "number",
    friendlyName: "Width (px)",
  },
  {
    name: "height",
    type: "number",
    friendlyName: "Height (px)",
  },
] as const satisfies Inputs;
